import { SelectionChangedEvent } from "ag-grid-community";
import { StdProposalTariffItemTierEntity } from "domain/entity/StandardProposal/StdProposalTariffItemTierEntity";
import { INITIAL_STANDARD_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF, transferRowData } from "presentation/constant/StandardProposal/StandardProposalTariffItemTierColumnDefinition";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import TariffItemForRecalHeaderBar from "./TariffItemForRecalHeaderBar";
import TariffItemTierEditPanel from "./TariffItemTierEditPanel";


const TariffItemTierForRecalTablePanel: React.FC = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();

    const { currentSelectedRow, isEdit, itemTierList, isShowEditTierPanel, currentItemRow, isShowTariffItemTierPanel } = proposalCopyingForRecalState;

    let gridRef: any = useRef();
    const messageBarVM = useMessageBarVM();

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        proposalCopyingForRecalVM.updateSelectedItemTierRows(selectedRows);
    }, [proposalCopyingForRecalVM])


    const handClose = useCallback(() => {
        proposalCopyingForRecalVM.onItemTierCloseClick();
    }, [proposalCopyingForRecalVM]);

    const handEdit = useCallback(() => {
        proposalCopyingForRecalVM.onItemTierEditClick();
    }, [proposalCopyingForRecalVM]);

    const handleSave = useCallback(() => {
        proposalCopyingForRecalVM.onShowLoading();
        proposalCopyingForRecalVM.onItemTierSave(currentItemRow).then(async data => {
            if ((data && data.success)) {
                messageBarVM.showSuccess("Save Successfully");
                await proposalCopyingForRecalVM.searchStandardProposalItem(currentSelectedRow);
                proposalCopyingForRecalVM.onHideLoading();
            } else {
                messageBarVM.showError(data.data ?? "Save Failed");
                proposalCopyingForRecalVM.onHideLoading();
                return;
            }
        });
    }, [currentItemRow, currentSelectedRow, messageBarVM, proposalCopyingForRecalVM]);

    const handleRecalItemTierDoubleClick = useCallback((entity: StdProposalTariffItemTierEntity) => {
        isEdit && proposalCopyingForRecalVM.onRecalItemTierDoubleClick(entity);
    }, [isEdit, proposalCopyingForRecalVM]);

    // const handDelete = useCallback(() => {
    //     if (selectedItemTierRows.length === 0) {
    //         messageBarVM.showError("Please select a record.");
    //         return;
    //     }
    //     if (itemTierList && (itemTierList.length === 1 || itemTierList.length === selectedItemTierRows.length)) {
    //         messageBarVM.showError("At least one tier is required.");
    //         return;
    //     }
    //     proposalCopyingForRecalVM.onItemTierDeleteClick(selectedItemTierRows);
    // }, [itemTierList, messageBarVM, proposalCopyingForRecalVM, selectedItemTierRows]);

    // const memoBtns = useMemo(() => {

    //     const hdrBtns = [];
    //     if (isEdit && !isShowEditTierPanel) {
    //         hdrBtns.push({
    //             id: 'onDeleteButton',
    //             icon: 'Icon-trash',
    //             title: 'Delete'
    //         })
    //     }

    //     return hdrBtns
    // }, [isEdit, isShowEditTierPanel])

    const isRowSelectable = useCallback(() => {
        return !(isShowEditTierPanel)
    }, [isShowEditTierPanel]);

    const memoStandardProposalTariffItemTierTable = useMemo(() => {

        return (
            <NbisTable
                id='standard-proposal-detail-table'
                isNewColumnSetting={true}
                columns={INITIAL_STANDARD_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF?.slice()}
                data={transferRowData(itemTierList ?? [])}
                // headerActionButtons={memoBtns}
                // onDeleteButton={handDelete}
                showPaginator={false}
                editable={false}
                showUploadIcon={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                onRowDoubleClick={(e: any, entity: StdProposalTariffItemTierEntity) => handleRecalItemTierDoubleClick(entity)}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 650px)"
                ref={gridRef}
                showPivotMode={false}
                handleRowSelectable={isRowSelectable}
            />
        );
    }, [handleRecalItemTierDoubleClick, handleSelectionChange, isRowSelectable, itemTierList])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowEditTierPanel])

    const memoTariffItemHeaderTable = useMemo(() => {
        return <TariffItemForRecalHeaderBar />
    }, [])

    const memoTariffItemTierEditPanel = useMemo(() => {
        return <TariffItemTierEditPanel />
    }, [])

    return <>
        <div className="main-comp-wrapper">
            <div style={{ width: '100%', height: '100%', maxHeight: '80%' }}>
                <Sidebarheader>
                    <SidebarTitle style={{ marginLeft: "10px" }}>{isShowTariffItemTierPanel ? "Tariff Item Tier" : "Edit"}</SidebarTitle>
                    <SidebarActionCross>
                        {!isEdit && !isShowTariffItemTierPanel && <IconButton
                            fileName="Icon-pen" size="medium" toolTipText='Edit' disabled={false} toolTipArrow={false} onClick={handEdit} />}
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' disabled={(isShowEditTierPanel)} toolTipArrow={false} onClick={handClose} />
                        {isEdit && <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' disabled={(isShowEditTierPanel)} toolTipArrow={false} onClick={handleSave} />}
                    </SidebarActionCross>
                </Sidebarheader>
                {memoTariffItemHeaderTable}
                <TableWrapper>
                    {memoStandardProposalTariffItemTierTable}
                </TableWrapper>

                {<div className={`child-div${(isShowEditTierPanel) ? " child-div-std-tariff-item-edit-expanded " : ""}`}>
                    {memoTariffItemTierEditPanel}
                </div>}
            </div>
        </div>
    </>;
}

export default memo(TariffItemTierForRecalTablePanel);
